/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignFormRequest
 */
export interface AssignFormRequest {
    /**
     * 
     */
    templateId?: string;
    /**
     * 
     */
    machineId?: string;
    /**
     * 
     */
    assignedOperatorId?: string;
    /**
     * 
     */
    dueAt?: string;
    /**
     * 
     */
    workPackNo?: string;
    /**
     * 
     */
    taskName?: string;
    /**
     * 
     */
    siteName?: string;
    /**
     * 
     */
    companyName?: string;
}

/**
 * Check if a given object implements the AssignFormRequest interface.
 */
export function instanceOfAssignFormRequest(value: object): value is AssignFormRequest {
    return true;
}

export function AssignFormRequestFromJSON(json: any): AssignFormRequest {
    return AssignFormRequestFromJSONTyped(json, false);
}

export function AssignFormRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignFormRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'assignedOperatorId': json['assignedOperatorId'] == null ? undefined : json['assignedOperatorId'],
        'dueAt': json['dueAt'] == null ? undefined : json['dueAt'],
        'workPackNo': json['workPackNo'] == null ? undefined : json['workPackNo'],
        'taskName': json['taskName'] == null ? undefined : json['taskName'],
        'siteName': json['siteName'] == null ? undefined : json['siteName'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
    };
}

export function AssignFormRequestToJSON(json: any): AssignFormRequest {
    return AssignFormRequestToJSONTyped(json, false);
}

export function AssignFormRequestToJSONTyped(value?: AssignFormRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'templateId': value['templateId'],
        'machineId': value['machineId'],
        'assignedOperatorId': value['assignedOperatorId'],
        'dueAt': value['dueAt'],
        'workPackNo': value['workPackNo'],
        'taskName': value['taskName'],
        'siteName': value['siteName'],
        'companyName': value['companyName'],
    };
}

